import {
    LogSearchFieldNames,
    LogSearchFunctionNames,
} from "./editor/schema.js";

const PreviewFieldNames = new Set<string>(LogSearchFieldNames);
const PreviewFunctionNames = new Set<string>(LogSearchFunctionNames);

function getTokenClass(token: string) {
    if (/^"[^"]*"?$/.test(token))
        return "cm-logsearch-string";

    if (/^(and|or|not|in|eq|ne|gt|ge|lt|le)$/.test(token))
        return "cm-logsearch-keyword";

    if (/^(>=|<=|==|!=|>|<)$/.test(token))
        return "cm-logsearch-operator";

    if (/^[(){}*,]$/.test(token) || token === "[*]")
        return "cm-logsearch-punctuation";

    if (PreviewFunctionNames.has(token))
        return "cm-logsearch-function";

    if (PreviewFieldNames.has(token) || token.startsWith("extra."))
        return "cm-logsearch-field";

    return "cm-logsearch-identifier";
}

export function renderExpressionPreview(expression: string) {
    const tokens = expression.match(/"[^"]*"?|\[\*\]|>=|<=|==|!=|>|<|\b(?:and|or|not|in|eq|ne|gt|ge|lt|le)\b|[a-zA-Z_][a-zA-Z0-9_.]*(?=\()|[a-zA-Z_][a-zA-Z0-9_.]*(?:\[\d+]|\[\*])?(?:\.[a-zA-Z_][a-zA-Z0-9_]*(?:\[\d+]|\[\*])?)*|[(){}*,]|\s+|./g) ?? [];

    return tokens.map((token) => (
        /^\s+$/.test(token)
            ? token
            : <span class={getTokenClass(token)}>{token}</span>
    ));
}
